export const TEST_IDS = {
  counterOfferCard: 'counter-offer-card',
  counterOfferInput: 'counter-offer-input',
  counterOfferAddButton: 'counter-offer-add-button',
  counterOfferOverflowMenu: 'counter-offer-overflow-menu',
}
